export default {
  ip: '',
  user: {},
  isUserDataLoading: false,
  partner: {},
  isPartnerDataLoading: false,
  accounts: {},
  isAccountsDataLoading: false,
  userProfile: {},
  isUserProfileLoading: false,
  isTradingAccountsLoading: true,
  tradingAccounts: [],
  isArchivedTradingAccountsLoading: false,
  archivedTradingAccounts: [],
  isTradesLoading: true,
  trades: [],
  tradesTotal: 0,
  tradesPagesCount: 1,
  ecnPromo: {},
  isEcnPromoLoading: false,
  isEnableEcnPromoLoading: false,
  applicationTitle: 'common.document.title',
  activeAccount: null,
  isOpenSuccessVerificationModal: false,
  walletId: 0,
  userCountry: '',
  mainChannelSocketMessages: [],
  withdrawalProcessingData: null,
  agoraUserProfile: {},
  isAgoraUserProfileLoading: true,
};
